import React from 'react'
import Spinner from '../../assets/spinner.svg'

export default function Fallback() {
  return (
    <main>
      <div className="flex items-center justify-center w-full h-screen -mt-16">
        <Spinner className="w-full text-purple-500" width={40} height={40} />
      </div>
    </main>
  )
}
